import { auth } from '../firebase'
import { downloadBlob, downloadUrl } from '../utils/downloadFile'

export const SIGN_COMPLETED = 'Annature_Sign_Completed'

const VAULT_STORAGE = 'vault'
const ANNATURE_STORAGE = 'annature'
const DOCUMENT_STORAGE = 'documents'

const DOCUMENT_STORAGE_PREFIX = 'document'
// NB: vault storage API prefix is just document with an "s". Not a bug, an API inconsistency
const VAULT_STORAGE_PREFIX = 'documents'

const documentDownloadSource = ({ offlineSigned, signStatus }) => {
  if (offlineSigned) {
    return VAULT_STORAGE
  }
  if (SIGN_COMPLETED === signStatus) {
    return ANNATURE_STORAGE
  }
  return DOCUMENT_STORAGE
}

export default {
  methods: {
    async downloadDocumentFile(theDocument) {
      try {
        await this._downloadFromSource(
          theDocument,
          documentDownloadSource(theDocument)
        )
      } catch (e) {
        this.$showErrorbar(
          'Error downloading document. Ensure you have enough document credits if you have not already sent or downloaded this document.'
        )
        this.$Sentry.captureException(e)
      }
    },
    async _downloadFromSource(theDocument, source) {
      switch (source) {
      case ANNATURE_STORAGE:
        return this._downloadDocumentFileFromAnnature(theDocument)
      case VAULT_STORAGE:
        return this._downloadDocumentFileFromVault(theDocument)
      case DOCUMENT_STORAGE:
        return this._downloadDocumentFileFromDocumentStorage(theDocument)
      default:
        throw Error(`Unknown download source: ${source}`)
      }
    },
    async _downloadDocumentFileFromAnnature({
      id: documentId,
      annaturePayload: { id: envelopeId }
    }) {
      const {
        data: { name, master: url }
      } = await this.$fireGet(
        `annature/document/${documentId}/download?envelopeId=${envelopeId}`,
        auth,
        {}
      )
      downloadUrl({ name, url })
    },
    _downloadDocumentFileFromVault(theDocument) {
      return this._blobDownloader(VAULT_STORAGE_PREFIX, theDocument)
    },
    _downloadDocumentFileFromDocumentStorage(theDocument) {
      return this._blobDownloader(DOCUMENT_STORAGE_PREFIX, theDocument)
    },
    async _blobDownloader(prefix, { id: documentId, modified }) {
      const dateString = this.$toLocaleYYYYMMDDsH_MMpString(modified.toDate())
      const fileDownload = await this.$fireGet(
        `${prefix}/${documentId}/download`,
        auth,
        undefined,
        { responseType: 'blob', headers: { 'user-date-string': dateString } }
      )
      downloadBlob(fileDownload)
    }
  }
}
